import axios from '../api/axios';

var DEFAULT_PRICES = {
  time: { price: 199800 },
  yuxie: { price: 499800 },
  live: { price: 1980000 },
  bill: { price: 99800 },
  publish: { price: 980000 },
};

function formatDuration(days) {
  if (days >= 36500) return '终身';
  if (days % 365 === 0) {
    var years = days / 365;
    return years === 1 ? '年' : years + '年';
  }
  return days + '天';
}

export function formatPrice(priceInFen, days) {
  if (priceInFen == null) return '';
  var yuan = priceInFen / 100;
  var price = Number.isInteger(yuan) ? yuan : yuan.toFixed(1);
  return days ? '\u00A5' + price + '/' + formatDuration(days) : '\u00A5' + price;
}

export function getPriceForBiz(biz) {
  var prices = window.app && window.app.goodsPrices;
  if (prices && prices[biz]) {
    return formatPrice(prices[biz].price, prices[biz].days);
  }
  var fallback = DEFAULT_PRICES[biz];
  return fallback ? formatPrice(fallback.price, fallback.days) : '';
}

export function fetchGoodsPrices() {
  return axios.get('/api/pub/goods/prices')
    .then(function (data) {
      if (data && typeof data === 'object') {
        if (!window.app) window.app = {};
        window.app.goodsPrices = data;
      }
      return data;
    })
    .catch(function (err) {
      console.warn('Failed to fetch goods prices, using defaults:', err);
      if (!window.app) window.app = {};
      window.app.goodsPrices = DEFAULT_PRICES;
      return DEFAULT_PRICES;
    });
}
